import { ConnectButton } from '@rainbow-me/rainbowkit'
import '@rainbow-me/rainbowkit/styles.css'
import { cn } from '@/lib/utils'
import { useChains } from 'wagmi'
import { Avatar } from './ui/Avatar'
import { useTracking } from '@/providers/TrackingProvider'
import { testIdFactory } from '@/utils/test-id-factory.ts'

export const RainbowKitCustomButton = ({ buttonClass, className }: { buttonClass?: string; className?: string }) => {
	const configuredChains = useChains()
	const { sendEvent } = useTracking()

	return (
		<ConnectButton.Custom>
			{({
				account,
				chain,
				openAccountModal,
				openChainModal,
				openConnectModal,
				authenticationStatus,
				mounted
			}) => {
				// Note: If your app doesn't use authentication, you
				// can remove all 'authenticationStatus' checks
				const ready = mounted && authenticationStatus !== 'loading'
				const connected =
					ready && account && chain && (!authenticationStatus || authenticationStatus === 'authenticated')

				return (
					<div
						{...(!ready && {
							'aria-hidden': true,
							style: {
								opacity: 0,
								pointerEvents: 'none',
								userSelect: 'none'
							}
						})}
						className={cn('leading-[1rem] w-full', className)}
					>
						{(() => {
							if (!connected) {
								return (
									<button
										data-testid={testIdFactory.walletConnectButton()}
										onClick={() => {
											sendEvent('click_connect_wallet')
											openConnectModal()
										}}
										type="button"
										className={cn(
											'text-neutral text-[1.5rem] px-8 py-[0.85rem] font-bold rounded-full bg-danger',
											buttonClass
										)}
									>
										Connect Wallet
									</button>
								)
							}

							if (chain.unsupported) {
								return (
									<button
										onClick={openChainModal}
										type="button"
										className={cn(
											'text-[1.5rem] text-danger px-8 py-2 rounded-full bg-red-200 leading-6',
											buttonClass
										)}
									>
										Wrong network
									</button>
								)
							}

							return (
								<div className="flex gap-2 flex-col md:flex-row w-full">
									{configuredChains.length > 1 && (
										<DisplayButton
											className="md:hidden"
											onClick={openChainModal}
											data-testid={testIdFactory.walletNetworkChangeButton()}
										>
											{chain.name}
										</DisplayButton>
									)}
									<DisplayButton
										onClick={openAccountModal}
										data-testid={testIdFactory.walletPopupButton()}
									>
										<Avatar address={account.address} size={20} className="mr-[10px]" />
										{account.displayName}
									</DisplayButton>
								</div>
							)
						})()}
					</div>
				)
			}}
		</ConnectButton.Custom>
	)
}

function DisplayButton(props: React.ButtonHTMLAttributes<HTMLButtonElement>) {
	return (
		<button
			{...props}
			className={cn(
				'bg-green-10 py-2 px-4 rounded-full text-[1.5rem] text-neutral-100 font-semibold flex justify-center items-center border-1 border-transparent leading-6 w-full',
				props.className
			)}
		/>
	)
}
